export default __webpack_public_path__ + "static/media/psdtohtml.2903f2ab.jpg";